module.exports = __webpack_public_path__ + "img/hy.c7229882.svg";